import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { removeSpecialCharacters } from 'crono-fe-common/utils';

export default function useAccountIndustries({
  limit,
  offset,
  text,
}: {
  limit: number;
  offset: number;
  text: string | null;
}) {
  // get key value object from searchParameters
  const queryString = new URLSearchParams({
    text: text ? removeSpecialCharacters(text) : '',
    limit: '' + limit,
    offset: '' + offset,
  }).toString();

  const request: Request = {
    url: ENDPOINTS.account.industries + '?' + queryString,
    config: {
      method: 'get',
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.account.industries, queryString],
    queryFn: () => client(request),
    staleTime: 60 * 1000,
  };

  const { data, ...rest } = useQuery<Response<string[]>, CronoError>(
    requestConfig,
  );

  return { data, ...rest };
}
